<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<g transform="translate(-1276.249 -224)">
			<path
				d="M35.75,4.75H33.875V1h-3.75V4.75H11.375V1H7.625V4.75H5.75A3.761,3.761,0,0,0,2,8.5v30a3.761,3.761,0,0,0,3.75,3.75h30A3.761,3.761,0,0,0,39.5,38.5V8.5A3.761,3.761,0,0,0,35.75,4.75Zm0,33.75h-30V14.125h30Z"
				transform="translate(1277.999 224.875)" />
			<path class="a" d="M0,0H45V45H0Z" transform="translate(1276.249 224)" />
		</g>
	</svg>
</template>

<script>
	export default {
		name: 'b-icon-calendar-today',
		components: {},
		computed: {},
		props: {},
	};
</script>

<style scoped lang="scss">
	path.a {
		fill: none;
	}
</style>

<docs>
	IconCalendarToday

	```js
	<b-icon-calendar-today />
	```
</docs>